import {Component, EventEmitter, Input, Output} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {CreateTemplateDialogComponent} from '../../create-template-dialog/create-template-dialog.component';

@Component({
  selector: 'app-delivery-cost-check-popup',
  templateUrl: './delivery-cost-check-popup.component.html',
  styleUrls: ['./delivery-cost-check-popup.component.scss'],
})

export class DeliveryCostCheckPopupComponent {
  @Output()
  onAdd = new EventEmitter<void>();
  @Output()
  onClear = new EventEmitter<void>();
  @Input()
  cost;
  @Input()
  announcedCost;
  message;
  description;
  confirmCloseTooltip;

  constructor(
    private dialogRef: MatDialogRef<CreateTemplateDialogComponent>,
  ) {
  }

  private _type;

  get type() {
    return this._type;
  }

  @Input() set type(value) {
    this._type = value;
    if (value === 'BackwardDeliveryData' || value === 'AdditionalServices') {
      this.message = 'Оголошена цінність буде дорівнювати сумі післяплати.';
      this.description = 'Оголошена цінність становитиме';
      this.confirmCloseTooltip = 'Сума післяплати буде дорівнювати оголошеній цінності.';
    } else {
      this.message = 'Оголошена цінність буде дорівнювати сумі контролю оплати.';
      this.description = 'Оголошена цінність становитиме';
      this.confirmCloseTooltip = 'Сума контролю оплати буде дорівнювати оголошеній цінності.';
    }
  };

  close(): void {
    this.onClear.next();
    this.dialogRef.close();
  }

  onButtonClick() {
    this.onAdd.next();
    this.dialogRef.close();
  }
}
